// Desc: Contact page component

import { ConfigurationAtom } from "_states";
import { useRecoilValue } from "recoil";

/**
 * ContactPage component
 * @returns {JSX.Element} JSX.Element
 */
const ContactPage = () => {
  const configurations = useRecoilValue(ConfigurationAtom);
  return (
    <section className="max-w-7xl mx-auto text-center space-y-8 pb-36 md:px-2 sm:px-4 px-4">
      <h2 className="font-semibold text-4xl text-center mb-10">
        Let's Connect
      </h2>
      <div className="text-lg space-y-12">
        <p>
          Feel free to reach out to us for any queries or feedback you may have.
          <br />
          We are happy to discuss your requirements, provide you with the best
          possible deals and plan an unforgettable trip for you.
        </p>
        <div>
          <p>
            Email:{" "}
            <a className="font-semibold">{configurations.contact_email}</a>
          </p>
          <p>
            Phone:{" "}
            <a className="font-semibold">{configurations.contact_number}</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
